module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-7-6bee68037a3ca4b0632a4716a52d58f8.webp";